import classNames from 'classnames'
import { Children } from 'react'

import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react'

import './styles.scss'

type DarkBackgroundProps =
  | {
      darkBackground?: boolean
      ghost?: true
    }
  | {
      darkBackground?: never
      ghost?: false
    }

export interface CommonProps {
  children?: ReactNode
  className?: string
  outlined?: boolean
  size?: Exclude<SIZES, 'large'>
}

type Props = DarkBackgroundProps & CommonProps

const Button = ({
  children,
  className,
  darkBackground,
  ghost,
  onClick,
  outlined,
  size = 'medium',
  type = 'button',
  ...props
}: Props & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement => {
  const buttonClasses = classNames('button-component', size, className, {
    'button-component--dark-background': darkBackground,
    'button-component--ghost': ghost,
    'button-component--outlined': outlined,
  })

  const childrenFormatted = Children.map(children, (child) =>
    typeof child === 'string' && child.trim().length > 0 ? <span>{child}</span> : child
  )

  return (
    <button {...props} className={buttonClasses} onClick={onClick} type={type}>
      {childrenFormatted}
    </button>
  )
}

export default Button
